import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"
import { GatsbyImage } from "gatsby-plugin-image"

const StyledGatsbyImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-height: 100%;

  .gatsby-image-wrapper {
    height: 100%;
    max-height: 100%;

    picture img {
      background: #fff;
    }
  }
`

const SmallGatsbyImage = ({ image, className, alt }) => {
  return (
    <StyledGatsbyImageWrapper className={className}>
      <GatsbyImage alt={alt ? alt : ""} image={image} />
    </StyledGatsbyImageWrapper>
  )
}

SmallGatsbyImage.propTypes = {
  image: PropTypes.object,
  alt: PropTypes.string,
  className: PropTypes.string,
}

export default SmallGatsbyImage
